import { DiContainer } from '@teachino/shared-util';
import type { FoldersFacade } from './folders/folders.facade';
import { FoldersService } from './folders/folders.service';
import type { SearchFacade } from './search/search.facade';
import { SearchService } from './search/search.service';
import type { TopicsFacade } from './topic/topics.facade';
import { TopicsService } from './topic/topics.service';
import { StudentsService } from './course/students.service';
import type { StudentsFacade } from './course/students.facade';
import type { MaterialsFacade } from './materials/materials.facade';
import { MaterialsService } from './materials/materials.service';
import { CourseTopicsService } from './course/course-topics.service';
import type { CourseTopicsFacade } from './course/course-topics.facade';
import type { ImageSearchFacade } from './image-search/image-search.facade';
import { ImageSearchService } from './image-search/image-search.service';
import type { CourseMaterialsFacade } from './course-material/course-materials.facade';
import { CourseMaterialsService } from './course-material/course-materials.service';

type Providers = {
  folders: FoldersFacade;
  search: SearchFacade;
  topics: TopicsFacade;
  students: StudentsFacade;
  materials: MaterialsFacade;
  courseMaterials: CourseMaterialsFacade;
  courseTopics: CourseTopicsFacade;
  imageSearch: ImageSearchFacade;
};

const diContainer = new DiContainer<Providers>();

export function useLibraryProvider() {
  function provide<K extends keyof Providers>(
    key: K,
    implementation: Providers[K],
  ) {
    diContainer.provide(key, implementation);
  }

  function inject<K extends keyof Providers>(key: K): Providers[K] {
    return diContainer.inject(key);
  }

  function configure(): void {
    diContainer.provide('search', new SearchService());
    diContainer.provide('folders', new FoldersService());
    diContainer.provide('topics', new TopicsService());
    diContainer.provide('students', new StudentsService());
    diContainer.provide('materials', new MaterialsService());
    diContainer.provide('courseMaterials', new CourseMaterialsService());
    diContainer.provide('courseTopics', new CourseTopicsService());
    diContainer.provide('imageSearch', new ImageSearchService());
  }

  return {
    provide,
    inject,
    configure,
  };
}
